import { render, staticRenderFns } from "./EvaluationTrainingColdGravityPage.vue?vue&type=template&id=85f84e36&"
import script from "./EvaluationTrainingColdGravityPage.vue?vue&type=script&lang=js&"
export * from "./EvaluationTrainingColdGravityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports